import { render, staticRenderFns } from "./UserFormGroups.vue?vue&type=template&id=4041cacf&scoped=true"
import script from "./UserFormGroups.vue?vue&type=script&lang=js"
export * from "./UserFormGroups.vue?vue&type=script&lang=js"
import style0 from "./UserFormGroups.vue?vue&type=style&index=0&id=4041cacf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4041cacf",
  null
  
)

export default component.exports